import React from "react";

function About() {
  return (
    <section
      name="about"
      className="w-full  bg-[#0f172a] text-gray-300 h-screen"
      id="about"
    >
      <div className="flex flex-col items-center justify-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="pb-8 pl-4 sm:text-right">
            <p className="inline text-4xl font-bold border-b-4 border-violet-600">
              About
            </p>
          </div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="text-4xl font-bold sm:text-right">
            <p>Hi,I'm Ahmaddin,nice to meet you.Please take a look around</p>
          </div>
          <div className="">
            <p>
              I am passionate about building excellent software that can improve
              the lives of people around me. My focus is on creating software
              for clients of all sizes, from individuals and small businesses to
              large enterprises.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
